var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"d-flex flex-column overflow-hidden panel-subsection"},[_c('div',{staticClass:"border-highlight"},[_vm._t("header")],2),_c('v-row',{staticClass:"scroll-section shrink",attrs:{"dense":"","no-gutters":""}},[_vm._t("scroll-section")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }